import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Logo from "../assets/shapes.png";
import Dialog from '@mui/material/Dialog';
import Button from "@mui/material/Button";
import Hero from "../assets/dragons/hero.png";
import {Link} from "react-router-dom";

const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#FF2E28",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "montserratbold",
                    fontSize: '1rem',
                    padding: '10px 14px',
                    borderRadius: '4',
                },
            }
        },
    }
});

const useStyles = theme => ({
    paper: {
        [theme.breakpoints.up('lg')]: {
            width: '600px !important',
            maxWidth: '600px !important',
        }
    },
    panel: {
        zIndex: '999',
        width: '100%',
        height: '100%',
        minHeight: '100%',
        display: 'flex',
        backgroundSize: 'cover',
    },
    content: {
        width: '100%',
        height: '100%',
        background: '#FFF',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '34px',
    },
    title: {
        fontFamily: 'Divona',
        fontSize: '2.7em',
        lineHeight: '1.2em',
        color: '#7B3938',
    },
    subtitle: {
        fontFamily: 'montserratbold',
        letterSpacing: '0.1em',
        margin: '12px 0',
        textTransform: 'uppercase',
        color: '#2D2824',
    },
    text: {
        margin: '0 0 20px 0',
        color: '#2D2824',
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btn: {
        margin: '0 10px',
        textAlign: 'left',
    },
});

class SpecialDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        const { classes } = this.props;
        let self = this;

        const handleClose = () => {
            self.props.onClose();
        };
        
        return (
            <ThemeProvider theme={muiTheme}>

                <Dialog classes={{ paper: classes.paper}} onClose={handleClose} open={self.props.open} PaperProps={{ sx: { borderRadius: "0px" } }}>
                    <div className={classes.panel}>
                        <div className={classes.content}>
                                <div className={classes.title}>Women's Self Defence Workshop</div>

                                <div className={classes.subtitle}>Sunday 21st September<br/>only $44.95*</div>

                            <div className={classes.text}>Our super popular workshop is back - combining self-defence, fitness, coordination and concentration at the wonderful Adelaide soul365.
                                <br/>(* use code <strong>women</strong>)
                            </div>

                                <div className={classes.footer}>
                                    <div className={classes.btn}><a href={"https://events.humanitix.com/self-defence-workshop-vtf4ydlj"} target="_blank"><Button variant="contained">Get $44.95 Tickets</Button></a></div>
                                    <div className={classes.btn}><Button onClick={handleClose} variant="outlined">No Thanks</Button></div>
                                </div>

                        </div>
                    </div>
                </Dialog>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(SpecialDialog)